<div class="dialog-wrapper" role="dialog" aria-modal="true" aria-labelledby="beneficiary-dialog-title" [formGroup]="form">

  <!-- Banner error -->
  <div class="info-banner error-banner" role="alert" *ngIf="showErrorBanner">
    <div class="info-banner-icon">
      <img src="assets/agricola/toast-warning.svg" alt="" aria-hidden="true">
    </div>
    <div class="info-banner-text">
      <span>Por favor, completa todos los campos obligatorios para continuar.</span>
    </div>
  </div>

  <h2 id="beneficiary-dialog-title" class="dialog-title">
    <img src="assets/agricola/header-user.svg" alt="" aria-hidden="true" class="title-icon" />
    {{ data.mode === 'edit' ? 'Editar beneficiario' : 'Añadir beneficiario' }}
  </h2>
  <p class="subtitle">Ingresa la información requerida para asignar participación.</p>

  <div class="available-section">
    <div class="available-label">{{ availableLabel }}</div>
    <div class="progress-bar">
      <div class="progress-fill" [style.width.%]="data.availableParticipation"></div>
    </div>
  </div>

  <div class="dialog-grid">

    <div class="field">
      <app-sis-field
        label="*Nombre completo"
        [error]="form.get('name')?.invalid && form.get('name')?.touched ? 'Ingresa nombre completo.' : ''"
        formControlName="name">
      </app-sis-field>
    </div>

    <div class="field">
      <app-sis-field
        label="*Porcentaje de participación"
        type="number"
        min="1"
        [max]="data.availableParticipation"
        [error]="percentageError"
        formControlName="percentage">
      </app-sis-field>
    </div>

    <div class="field">
      <app-sis-select
        label="*Parentesco"
        placeholder="Selecciona parentesco"
        [options]="relationshipOptions"
        [loading]="relationshipLoading"
        [loadedKey]="relationshipLoadedKey"
        loadedMessage="Catálogo de parentescos cargado"
        [loadFailed]="relationshipLoadFailed"
        (retryLoad)="retryRelationship()"
        [caption]="relationshipCaption"
        [helper]="relationshipLoading ? 'Cargando parentescos...' : ''"
        [error]="form.get('relationship')?.invalid && form.get('relationship')?.touched ? 'Selecciona parentesco.' : ''"
        formControlName="relationship">
      </app-sis-select>
    </div>

    <div class="field">
      <app-sis-select
        label="*Tipo de identificación"
        placeholder="Selecciona tipo"
        [options]="identificationTypeOptions"
        [error]="form.get('identification_type')?.invalid && form.get('identification_type')?.touched ? 'Selecciona tipo de identificación.' : ''"
        formControlName="identification_type">
      </app-sis-select>
    </div>

    <div class="field">
      <app-sis-field
        label="*Número de identificación"
        [error]="identificationError"
        formControlName="identification_id">
      </app-sis-field>
    </div>

    <div class="field">
      <app-sis-date-field
        label="Fecha de nacimiento"
        helper="Opcional"
        formControlName="birthday">
      </app-sis-date-field>
    </div>

  </div>

  <div class="dialog-actions">
    <app-sis-button variant="secondary" (pressed)="cancel()">CANCELAR</app-sis-button>
    <app-sis-button (pressed)="save()">GUARDAR</app-sis-button>
  </div>
</div>
